
import isNil from 'lodash/isNil';

const VALUES = [
    {name: 'length', title: 'Délka', unit: 'm'},
    {name: 'lengthXY', title: 'Délka v rovině XY', unit: 'm'},
    {name: 'lengthZ', title: 'Rozdíl Z souřadnic', unit: 'm'},
    {name: 'lengthLastSegment', title: 'Délka posledního segmentu', unit: 'm'},
    {name: 'slopeAngle', title: 'Sklon ve stupních', unit: '°'},
    {name: 'slopePercent', title: 'Sklon v procentech', unit: '%'},
    {name: 'area', title: 'Obsah', unit: 'm²'},
    {name: 'areaXY', title: 'Obsah v rovině XY', unit: 'm²'},
    {name: 'perimeter', title: 'Obvod', unit: 'm'},
    {name: 'perimeterXY', title: 'Obvod v rovině XY', unit: 'm'},
    {name: 'width', title: 'Šířka', unit: 'm'},
    {name: 'height', title: 'Výška', unit: 'm'}
]

export function getValueDefinitions(measureValues) {
    let values = [];
    VALUES.forEach(item => {
        if (!isNil(measureValues[item.name])) {
            values.push({
                ...item,
                value: measureValues[item.name]
            });
        }
    });
    return values;
}

export function getValueAsCsvRow(name, value) {
    return VALUES.reduce((previous, current) => {
        return (current.name === name)
            ? `${current.title};${value.toFixed(2)};${current.unit}`
            : previous;
    }, '');
}

export function getMainValue(measureValues) {
    return VALUES.reduce((previous, current) => {
        const measureValue = measureValues[current.name];
        return (measureValue && !previous)
            ? {
                value: measureValue,
                definition: current
            }
            : previous;
    }, null);
}